import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { useExplorerConfig } from 'lib/contexts/ExplorerConfigContext';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import SearchBar from 'ui/snippets/searchBar/SearchBar';

const HeroBanner = () => {
  const { config: explorerConfig } = useExplorerConfig();
  const heroBannerImage = explorerConfig?.about_page_images?.hero_banner;
  const chainName = config.chain.name || 'Explorer';
  return (
    <Box
      className={ heroBannerImage ? 'HeroBanner HeroBanner--custom-image' : 'HeroBanner' }
      w="100vw"
      position="relative"
      left={{ base: 'auto', lg: '50%' }}
      right={{ base: 'auto', lg: '50%' }}
      marginLeft={{ base: 0, lg: '-50vw' }}
      marginRight={{ base: 0, lg: '-50vw' }}
      background={ heroBannerImage ? undefined : 'linear-gradient(135deg, #0A1D36 0%, #0A1D36 100%)' }
      sx={ heroBannerImage ? {
        background: `url(${ heroBannerImage }) no-repeat center/cover !important`,
        backgroundImage: `url(${ heroBannerImage }) !important`,
        backgroundColor: 'transparent !important',
      } : undefined }
      pt={{ base: 6, lg: 10 }}
      pb={{ base: 12, lg: 36 }}
      minH={{ base: 'auto', lg: '32vh' }}
      borderRadius="0"
    >
      <Box maxW={ `${ CONTENT_MAX_WIDTH }px` } mx="auto" px={{ base: 3, lg: 6 }} pb={{ base: 4, lg: 14 }}>
        { /* Title */ }
        <Heading
          as="h1"
          fontSize={{ base: '18px', lg: '20px' }}
          lineHeight={{ base: '24px', lg: '28px' }}
          fontWeight={ 500 }
          color="white"
          mb={{ base: 3, lg: 5 }}
        >
          The { chainName } Explorer
        </Heading>

        { /* Search Bar */ }
        <SearchBar isHomepage/>

        {/* sponsored banner removed */}
      </Box>
    </Box>
  );
};

export default React.memo(HeroBanner);
